<template>
  <div>
    <div v-if="referral" class="font-weight-bold">
      Created by referral:
      <span style="color: #4caf50">{{ referral.name }} / {{ referral.email }}</span>
    </div>
    <div v-if="currentScenarioTitle" class="pt-8">
      <div v-if="currentScenarioTitle === allScenariosTitles.scenarioATitle">
        <ScenarioASavedResult />
      </div>
      <div v-if="currentScenarioTitle === allScenariosTitles.scenarioBTitle">
        <ScenarioBSavedResult />
      </div>
      <div v-if="currentScenarioTitle === allScenariosTitles.scenarioCTitle">
        <ScenarioCSavedResult />
      </div>
      <div v-if="currentScenarioTitle === allScenariosTitles.scenarioDTitle">
        <ScenarioDSavedResult />
      </div>
      <div v-if="currentScenarioTitle === allScenariosTitles.scenarioETitle">
        <ScenarioESavedResult />
      </div>
    </div>

    <LeadCaptureDescription />
    <Footer />
  </div>
</template>

<script>
import ScenarioASavedResult from '@/components/ScenarioA/SavedResult/index.vue';
import ScenarioBSavedResult from '@/components/ScenarioB/SavedResult/index.vue';
import ScenarioCSavedResult from '@/components/ScenarioC/SavedResult/index.vue';
import ScenarioDSavedResult from '@/components/ScenarioD/SavedResult/index.vue';
import ScenarioESavedResult from '@/components/ScenarioE/SavedResult/index.vue';
import Footer from '@/components/LeadCapture/Footer.vue';
import LeadCaptureDescription from '@/components/LeadCapture/Description/index.vue';

export default {
  components: {
    ScenarioASavedResult,
    ScenarioBSavedResult,
    ScenarioCSavedResult,
    ScenarioDSavedResult,
    ScenarioESavedResult,
    Footer,
    LeadCaptureDescription
  },
  computed: {
    currentScenarioTitle() {
      return this.$store.state.scenarioData.scenario;
    },
    allScenariosTitles() {
      return this.$store.state.scenarioData.allScenarioTitles;
    },
    referral() {
      return this.$store.state.scenarioData.referral;
    }
  },
  created() {
    console.log('saved result');
    this.$store.commit('setExpanded', 0);
  }
};
</script>
